import { createSlice } from "@reduxjs/toolkit";
import { SearchFieldState } from "../types";

const initialState: SearchFieldState = {
  awaitingAskResponse: false,
  globalSearchText: "",
  shouldSubmit: false,
};

const searchFieldSlice = createSlice({
  name: "searchField",
  initialState,
  reducers: {
    setAwaitingAskResponse(state, action) {
      state.awaitingAskResponse = action.payload;
    },
    setGlobalSearchText(state, action) {
      state.globalSearchText = action.payload;
    },
    setTextAndSubmit: (state, action) => {
      state.globalSearchText = action.payload;
      state.shouldSubmit = true;
    },
    clearSubmitFlag: (state) => {
      state.globalSearchText = "";
      state.shouldSubmit = false;
    },
  },
});

export default searchFieldSlice.reducer;
export const searchFieldActions = searchFieldSlice.actions;
